
function CMainSettings()
{
    CMainSettings.prototype.reset = function()
    {
        this.Domain = '';
        this.UserNoHeartbeatAckKickout = 0;
        this.FinalizeTimeOut = 0;
        this.MaxDailyGuoZhaoCnt = 0;
        this.GuoZhaoPeriods = null;
        this.InScoreBonusBase = 0;
        this.InScoreBonusFormal = 0;
        this.InScoreBonusTrial = 0;
        this.CanExchangeTrialToFormal = false;
        this.CanExchangeFormalToTrial = false;
        this.ExchangeRatio = 0;
        this.ExchangeMinLeft = 0;
        this.ExchangeReceiverRate = 0;
        this.CanExchangeUniPlayToFormal = false;
        this.CanExchangeFormalToUniPlay = false;
        this.GiftTaxRate = 0;
        this.DailyAward = 0;
        this.AwardType = null;
        this.MaxDailyAward = 0;
        this.AwardDuration = 0;
        this.StopAwardAt = 0;
        this.VerifyUserInfo = true;
        this.ShowPlayerLevel = false;
        this.ShowBetReward = false;
        this.MinExchangeBetReward = 0;
        this.MaxExchangeBetReward = 0;
    }

    CMainSettings.prototype.parse = function(objMainSettings)
    {
        try {
            if (objMainSettings.hasOwnProperty('Domain')) this.Domain = objMainSettings.Domain;
            if (objMainSettings.hasOwnProperty('UserNoHeartbeatAckKickout')) this.UserNoHeartbeatAckKickout = objMainSettings.UserNoHeartbeatAckKickout;
            if (objMainSettings.hasOwnProperty('FinalizeTimeOut')) this.FinalizeTimeOut = objMainSettings.FinalizeTimeOut;
            else if (objMainSettings.hasOwnProperty('FinaleTimeOut')) this.FinalizeTimeOut = objMainSettings.FinaleTimeOut;
            if (objMainSettings.hasOwnProperty('MaxDailyGuoZhaoCnt')) this.MaxDailyGuoZhaoCnt = objMainSettings.MaxDailyGuoZhaoCnt;
            if (objMainSettings.hasOwnProperty('GuoZhaoPeriods')) this.GuoZhaoPeriods = objMainSettings.GuoZhaoPeriods;
            if (objMainSettings.hasOwnProperty('InScoreBonusBase')) this.InScoreBonusBase = objMainSettings.InScoreBonusBase;
            if (objMainSettings.hasOwnProperty('InScoreBonusFormal')) this.InScoreBonusFormal = objMainSettings.InScoreBonusFormal;
            if (objMainSettings.hasOwnProperty('InScoreBonusTrial')) this.InScoreBonusTrial = objMainSettings.InScoreBonusTrial;
            if (objMainSettings.hasOwnProperty('CanExchangeTrialToFormal')) this.CanExchangeTrialToFormal = objMainSettings.CanExchangeTrialToFormal;
            if (objMainSettings.hasOwnProperty('CanExchangeFormalToTrial')) this.CanExchangeFormalToTrial = objMainSettings.CanExchangeFormalToTrial;
            if (objMainSettings.hasOwnProperty('ExchangeRatio')) this.ExchangeRatio = objMainSettings.ExchangeRatio;
            if (objMainSettings.hasOwnProperty('ExchangeMinLeft')) this.ExchangeMinLeft = objMainSettings.ExchangeMinLeft;
            if (objMainSettings.hasOwnProperty('ExchangeReceiverRate')) this.ExchangeReceiverRate = objMainSettings.ExchangeReceiverRate;
            if (objMainSettings.hasOwnProperty('CanExchangeUniPlayToFormal')) this.CanExchangeUniPlayToFormal = objMainSettings.CanExchangeUniPlayToFormal;
            if (objMainSettings.hasOwnProperty('CanExchangeFormalToUniPlay')) this.CanExchangeFormalToUniPlay = objMainSettings.CanExchangeFormalToUniPlay;
            if (objMainSettings.hasOwnProperty('GiftTaxRate')) this.GiftTaxRate = objMainSettings.GiftTaxRate;
            if (objMainSettings.hasOwnProperty('DailyAward')) this.DailyAward = objMainSettings.DailyAward;
            if (objMainSettings.hasOwnProperty('AwardType')) this.AwardType = objMainSettings.AwardType;
            if (objMainSettings.hasOwnProperty('MaxDailyAward')) this.MaxDailyAward = objMainSettings.MaxDailyAward;
            if (objMainSettings.hasOwnProperty('AwardDuration')) this.AwardDuration = objMainSettings.AwardDuration;
            if (objMainSettings.hasOwnProperty('StopAwardAt')) this.StopAwardAt = objMainSettings.StopAwardAt;
            if (objMainSettings.hasOwnProperty('VerifyUserInfo')) this.VerifyUserInfo = objMainSettings.VerifyUserInfo;
            if (objMainSettings.hasOwnProperty('ShowPlayerLevel')) this.ShowPlayerLevel = objMainSettings.ShowPlayerLevel;
            if (objMainSettings.hasOwnProperty('ShowBetReward')) this.ShowBetReward = objMainSettings.ShowBetReward;
            if (objMainSettings.hasOwnProperty('MinExchangeBetReward')) this.MinExchangeBetReward = objMainSettings.MinExchangeBetReward;
            if (objMainSettings.hasOwnProperty('MaxExchangeBetReward')) this.MaxExchangeBetReward = objMainSettings.MaxExchangeBetReward;
            return true;
        }
        catch(error) {
        }
        return false;
    }
}

module.exports = {
    create: function() {
        const mainSettings = new CMainSettings();
        mainSettings.reset();
        return mainSettings;
    }
};